module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/placeholders/avatar-0954b04c6a77aaab44b876d611c50217.png";